import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../app/store";
import { PageState, Template } from "../api/Types";
import { getTemplates } from "../api/SwyftApi";

interface TemplateState {
  pageState: PageState;
  templates: Template[] | undefined;
  error: string | null;
}

const initialState: TemplateState = {
  pageState: PageState.Loading,
  templates: undefined,
  error: null
};

function startLoading(state: TemplateState) {
  state.pageState = PageState.Loading;
}

function loadingFailed(state: TemplateState, action: PayloadAction<string>) {
  state.pageState = PageState.Error;
  state.error = action.payload;
}

const template = createSlice({
  name: "template",
  initialState,
  reducers: {
    getTemplatesStart: startLoading,
    getTemplatesSuccess(state, { payload }: PayloadAction<Template[]>) {
      state.pageState = PageState.Ready;
      state.templates = payload;
      state.error = null;
    },
    getTemplatesFailure: loadingFailed
  }
});

export const { getTemplatesStart, getTemplatesSuccess, getTemplatesFailure } = template.actions;

export default template.reducer;

export const fetchTemplates = (): AppThunk => async (dispatch) => {
  try {
    dispatch(getTemplatesStart());
    const templates = await getTemplates();
    dispatch(getTemplatesSuccess(templates));
  } catch (err: any) {
    dispatch(getTemplatesFailure(err.toString()));
  }
};
